import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

export const Charactersheets = {
  namespaced: true,
  state: {
    gamesystem: 0,
    profile: {
      name: '',
      job: '',
      sex: '',
      age: '',
      privateCheck: false,
    },
    status: {
      str: 0,
      con: 0,
      pow: 0,
      dex: 0,
      app: 0,
      siz: 0,
      int: 0,
      edu: 0,
      luk: 0,
      idea: 0,
      knowledge: 0,
      san: 0,
      hp: 0,
      mp: 0,
      dbns: 'none',
      build: 0,
      mov: 0,
    },
    skill: [],
    other: {
      career: '',
      income: '',
      belongings: '',
      notices: '',
    },
    backStory: {
      appearance: '',
      ideology: '',
      keyPerson: '',
      keyPoing: '',
      precious: '',
      characteristic: '',
      scar: '',
      phobia: '',
      artifact: '',
      encount: '',
    },
    uid: '',
    skillList: [],
    isPrivate: false,
    jobPointFormula: 0,
  },
  getters,
  mutations,
  actions,
};
